const columns = [
  {
    title: "内容导航",
    links: [
      { label: "稿费单价", href: "#rates" },
      { label: "收益构成", href: "#value" },
      { label: "投稿流程", href: "#flow" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    title: "投稿实用信息",
    links: [
      { label: "图文瓜料报价", href: "#rates" },
      { label: "独家视频报价", href: "#rates" },
      { label: "避坑清单", href: "#faq" },
      { label: "订阅指南", href: "#subscribe" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-secondary-100/50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2" aria-label="回到顶部">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
                <i className="ri-empathize-line" aria-hidden="true"></i>
              </span>
              <span className="font-display text-xl text-foreground-950">吃瓜投稿攻略</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注把吃瓜投稿的稿费单价、收益构成、结算与提现讲清楚。本站内容为经验与信息分享，不构成收益承诺，具体以你投稿平台的实际规则为准。
            </p>
          </div>
          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="text-sm font-semibold uppercase tracking-wide text-foreground-800">
                {col.title}
              </h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/80 pt-6 sm:flex-row">
          <p className="text-sm text-foreground-500">
            © {new Date().getFullYear()} 吃瓜投稿攻略 · 仅供学习与交流参考
          </p>
          <p className="text-sm text-foreground-500">理性吃瓜 · 真实投稿 · 稳稳提现</p>
        </div>
      </div>
    </footer>
  );
}